export const testAccess = (user, type) => {
    if(user.role === 'AGENT'){
        return user.access[type]
    }else{
        return true;
    }
}